import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';

import { RootDispatch, RootState } from 'storage/store';
import { Url } from 'utils/urls';
import { events, apiEvents } from 'utils/Api/Api';

const unLoggedUserUrls: string[] = [
  Url.technicalBreak,
  Url.unloggedContact,
  Url.faq,
  Url.privacyPolicy
];

const SigmaAvailabilityGuard = () => {
  const dispatch = useDispatch<RootDispatch>();
  const {
    sigmaAvailable,
    contractDashboardFeatureToggle: contractToggle,
    toggleLoading
  } = useSelector((store: RootState) => store.application);
  const { pathname: path } = useLocation();

  const shouldCheckSigmaAvailability = !unLoggedUserUrls.includes(path);
  const [loading, setLoading] = useState(shouldCheckSigmaAvailability);
  const shouldNavigateToTechnicalBreak =
    !loading && shouldCheckSigmaAvailability && !sigmaAvailable;

  useEffect(() => {
    if (!toggleLoading) {
      if (contractToggle) {
        setLoading(false);
        return;
      }
      if (!contractToggle && shouldCheckSigmaAvailability) {
        dispatch.application.getSigmaAvailability().then(() => {
          setLoading(false);
        });
      }
    }
  }, [path, contractToggle, toggleLoading]);

  useEffect(() => {
    if (shouldCheckSigmaAvailability) {
      events.on(apiEvents.SIGMA_TIMEOUT, () => {
        dispatch.user.logoutUser();
        window.location.pathname = Url.technicalBreak;
      });
    }
  }, []);

  if (loading) {
    return null;
  }
  if (shouldNavigateToTechnicalBreak) {
    return <Navigate to={Url.technicalBreak} replace />;
  }

  return <Outlet />;
};

export default SigmaAvailabilityGuard;
